import { render, staticRenderFns } from "./AboutUsPart1.vue?vue&type=template&id=690d6bee&scoped=true&"
import script from "./AboutUsPart1.vue?vue&type=script&lang=js&"
export * from "./AboutUsPart1.vue?vue&type=script&lang=js&"
import style0 from "./AboutUsPart1.vue?vue&type=style&index=0&id=690d6bee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "690d6bee",
  null
  
)

export default component.exports